module.exports = {
  salesOrderNumber: '平台订单编码',
  returnOrderNumber: '平台退货编号',
  returnTrackingNumber: '退回快递单号',
  exceptionCaseNumber: 'Exception Case Number',
  uploadQueryData: 'Upload Query Data',
  exportResults: '导出结果',
  tableTitle: '本列表请展示前10条预览数据，更多明细请参考导出结果。',
  tableCol1: '平台退货编号',
  tableCol2: '退回快递单号',
  tableCol3: '平台退货申请时间',
  tableCol4: '退货单标签',
  tableCol5: '退货单状态',
  tableCol6: '路由状态',
  tableCol7: '店铺信息',
  tableCol8: '平台订单编码',
  tableCol9: '是否退款'
}
